import { lazy } from 'react';

const InputNumber = lazy(() => import('./InputNumber'));

export { InputNumber };
